export const LIST_CONTAINER =
  'no-scrollbar flex flex-col divide-y outline-default divide-default overflow-clip rounded-lg outline outline-1 -outline-offset-1 bg-surface-raised'

export const EMPTY_STATE =
  'border border-dashed border-default px-3.5 py-2.5 text-center text-sm text-secondary'

/** Applied to the focusable row element (inner div for handler rows, <a> for link rows). */
export const ROW_FOCUS_RING =
  'focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus'
